import { createHttpLink } from "@apollo/client/core";
import type { DefaultOptions } from "@apollo/client/core";
import cfg from "$lib/config/config";

const getProtocol = () => {
  if (process.env.NODE_ENV === "development") {
    return cfg.CMS_ENDPOINT.includes("localhost") ? "http://" : "https://";
  }

  return "https://";
};

const protocol = getProtocol();
const cmsPublicEndpoint = `${protocol}${cfg.CMS_ENDPOINT}/graphql`;

const cmsInternalEndpoint = cfg.CMS_INTERNAL_ENDPOINT || cmsPublicEndpoint;

const shopifyStore = `${cfg.SHOPIFY_STORE}.myshopify.com`;

export const isServer = typeof window === "undefined";

const cmsEndpoint = isServer ? cmsInternalEndpoint : cmsPublicEndpoint;

export const cmsHttpLink = createHttpLink({
  uri: cmsEndpoint,
  fetch,
});

export const ssrOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore",
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all",
  },
};

export const baseHeaders = (headers: any) => {
  return {
    ...headers,
    Accept: "application/json",
    "Storefront-Domain": shopifyStore,
  };
};
